import { styled } from '@mui/material/styles';
import { type ButtonProps, IconButton as MuiIconButton, type IconButtonProps as MuiIconButtonProps } from '@mui/material';

import { createButtonStyles } from '~/utils/createButtonStyles';

type IconButtonShapeProps = 'rounded' | 'square';

type IconButtonProps = MuiIconButtonProps & {
    shape?: IconButtonShapeProps | undefined;
    variant?: ButtonProps['variant'] | undefined;
};

export const IconButton = styled(MuiIconButton, {
    shouldForwardProp: (prop) => prop !== 'shape' && prop !== 'variant',
})<IconButtonProps>(
    ({ color, variant, shape, theme }) => ({
        borderRadius: shape === 'rounded' ? '50%' : 4,
        ...(color !== 'inherit' && createButtonStyles(theme, variant, color))
    })
);
